export default {
  alert: {
    snackbar: false,
    color: 'error',
    mode: '',
    timeout: 3000,
    text: 'Erro de comunicação com o servidor, por favor verifique sua conexão e tente novamente.'
  }
}
